import apiRequest from '@/utils/apiRequest';

/**
 * 站点配置接口
 */
export interface SiteConfig {
    /**
     * 项目名称
     */
    projectName: string;

    /**
     * 用户端名称
     * 用于用户端页面标题和登录、注册等页面显示
     */
    clientName: string;

    /**
     * 站点图标 (base64)
     */
    icon: string;

    /**
     * APP 下载链接
     */
    appDownloadUrl: string;

    /**
     * 充值积分转换比例
     * 1元人民币能兑换多少积分
     * 示例：100 表示 1元 = 100积分
     */
    rechargePointsRatio?: number;

    /**
     *
     */
    bankCardWithdrawEnabled?: boolean;
    /**
     *
     */
    alipayWithdrawEnabled?: boolean;

    /**
     * 代理推广说明
     * 用于用户端代理推广页面显示，支持多行文本
     */
    promoDescription?: string;

    /**
     * 系统消息显示用户名
     * 用于系统消息用户化显示，默认"系统助手"
     */
    systemUserName?: string;

    /**
     * 系统消息显示头像
     * 用于系统消息用户化显示，base64 格式
     */
    systemUserAvatar?: string;

    /**
     * 微信浏览器引导开关
     * 启用后，在微信内置浏览器访问时会显示引导蒙层，提示用户在外部浏览器打开
     */
    wechatBrowserGuideEnabled?: boolean;
}

/**
 * 获取站点配置（包含积分转换比例）
 */
export async function getSiteConfig() {
    return apiRequest<SiteConfig>('/public/siteConfig', {
        method: 'GET',
    });
}
